import {
	canonical,
	generateBreadcrumbStructuredDataMarkup,
} from "@/common/functions";

export default function() {
	return {
		title: this.$t("WordscapesDailyIndexPageMetaTitle"),
		meta: [
			{
				name: "description",
				content: this.$t("WordscapesDailyIndexPageMetaDescription"),
			},
		],
		script: [
			{
				type: "application/ld+json",
				json: generateBreadcrumbStructuredDataMarkup([
					{ name: "Daily Puzzles", path: "/daily-puzzle/" },
				]),
			},
		],
		link: [canonical(this.$route)],
	};
}
